import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { installErrorReporter } from './bugminerReporter';

// Passive browser-error capture → POST /api/client-errors → log-triage backlog. Fail-silent.
installErrorReporter({ app: 'payment-service' });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
